// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import { Table as DataTable, Button, notification } from 'antd';
import axios from 'axios';
import '../css/antd.css';
import { CSVLink } from 'react-csv';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // Import the autoTable plugin
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';
import ModalForm from './ModalForm';
import DeleteModal from './DeleteModal';

import { APP_LOGO } from '../constants';
import UpdateModal from './UpdateModal';
import { decodeToken } from '../utils/TokenUtils';
import { API_URL, ENDPOINTS } from '../constants/api';
import FeatherIcon from 'feather-icons-react';
import { removeColumns, removeFields } from '../utils/ktcUtils';
import DetailData from './DetailData';

const DTTable = ({
  data,
  reportHeader,
  reportFooter,
  link,
  token,
  executionTime,
}) => {
  const title = link?.page_title;

  const userId = decodeToken(token, 'id');
  const companyBanner = decodeToken(token, 'banner');
  //console.log('link:', link)

  const [columns, setColumns] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [printedId, setPrintedId] = useState(null);

  const [updateTable, setUpdateTable] = useState(null);
  const [currentRoute, setCurrentRoute] = useState(null);

  const [selectedColumns, setSelectedColumns] = useState([]);
  const [columns2, setColumns2] = useState([]);

  const fieldsToRemove = ['Action', 'Image', 'Print'];

  var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/add-print-log`;

  const [modalVisible, setModalVisible] = useState(false); // Manage modal visibility

  // Function to handle delete button click
  const handleDelete = (id) => {
    setDeleteId(id);
    setModalVisible(true); // Open the modal on delete click
  };

  const handleCancel = () => {
    setModalVisible(false); // Close the modal without deleting
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const openModal2 = (route) => {
    setCurrentRoute(route);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const [isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);

  const openUpdateModal = (id) => {
    setUpdateId(id);
    // setUpdateTable()
    setIsModalUpdateOpen(true);
  };
  const closeUpdateModal = () => {
    setUpdateId(0);
    setIsModalUpdateOpen(false);
  };

  const [isModalPrintOpen, setIsModalPrintOpen] = useState(false);

  const openPrintModal = (id) => {
    setPrintedId(id);
    // setUpdateTable()
    setIsModalPrintOpen(true);
  };
  const closePrintModal = () => {
    setUpdateId(0);
    setIsModalPrintOpen(false);
  };

  // Function to dynamically generate columns from the first row of data
  const generateColumns = (data) => {
    if (data.length === 0) return []; // If data is empty, return empty columns

    // Get the keys from the first row of data (assuming it's an object)
    const keys = Object.keys(data[0]);

    // Map through the keys to generate column definitions
    return keys.map((key) => ({
      title: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize column title
      dataIndex: key,
      key: key,
      sorter: (a, b) => {
        if (typeof a[key] === 'number' && typeof b[key] === 'number') {
          return a[key] - b[key];
        } else if (typeof a[key] === 'string' && typeof b[key] === 'string') {
          return a[key].localeCompare(b[key]);
        } else {
          return 0;
        }
      },
      sortDirections: ['ascend', 'descend'],
      render: (text) => {
        if (typeof text === 'string') {
          // Regex to extract href, class, and inner text
          const anchorRegex =
            /<a[^>]+href="([^"]+)"[^>]*className="([^"]+)"[^>]*>([^<]+)<\/a>/;
          const match = text.match(anchorRegex);

          if (match) {
            const href = match[1]; // Extract the href
            const className = match[2]; // Extract the class
            const displayText = match[3]; // Extract the inner text

            // Check if it's a custom link with "updatecolumn/"
            if (href.startsWith('updatecolumn/')) {
              return (
                <button
                  className={`btn ${className}`}
                  onClick={(e) => updateColumn(e, href)}
                >
                  {displayText}
                </button>
              );
            }

            // Check if it's a custom link with "undo-/" for undo delete and update
            if (href.startsWith('undo-')) {
              return (
                <button
                  className={`btn ${className}`}
                  onClick={(e) => undoDelUpdate(e, href)}
                >
                  {displayText}
                </button>
              );
            }

            // Check if it's a custom link with "undo-/" for undo delete and update
            if (href.startsWith('printedDataId/')) {
              const printedDataId = href.split('/')[1];
              return (
                <button
                  className={`btn ${className}`}
                  onClick={(e) => openPrintModal(printedDataId)}
                >
                  {displayText}
                </button>
              );
            }

            // Otherwise, render it as a regular link
            return (
              <a
                href={href}
                className={`btn ${className}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {displayText}
              </a>
            );
          }
          // Check for image file extensions
          if (
            text.endsWith('.jpg') ||
            text.endsWith('.png') ||
            text.endsWith('.jpeg') ||
            text.endsWith('.gif')
          ) {
            return (
              <img
                src={`${API_URL}/${text}`}
                alt="image"
                style={{ width: 50, height: 50, objectFit: 'cover' }}
              />
            );
          }

          // Check for document file extensions
          if (
            text.endsWith('.pdf') ||
            text.endsWith('.doc') ||
            text.endsWith('.docx')
          ) {
            return (
              <a
                href={`${API_URL}/${text}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#007bff', textDecoration: 'underline' }}
              >
                Preview or Download
              </a>
            );
          }
        }
        return text; // Render plain text for other types
      },
    }));
  };

  // Handle checkbox toggle
  const handleCheckboxChange = (columnName) => {
    setSelectedColumns((prevSelected) => {
      if (prevSelected.includes(columnName)) {
        // If already selected, remove it
        return prevSelected.filter((col) => col !== columnName);
      } else {
        // If not selected, add it
        return [...prevSelected, columnName];
      }
    });
  };

  useEffect(() => {
    // Dynamically create columns based on data keys
    const cols = generateColumns(data);
    const editDelColumns = {
      title: 'Action',
      key: 'Action',
      render: (_, record) => (
        <>
          <Button type="danger" onClick={() => openUpdateModal(record.ID)}>
            <FeatherIcon
              icon="edit"
              size={20}
              style={{ cursor: 'pointer', color: '#007bff' }}
            />
          </Button>

          <Button
            type="danger"
            onClick={() => handleDelete(record.ID)}
            loading={loading && deleteId === record.ID}
          >
            <FeatherIcon
              icon="trash-2"
              size={20}
              style={{ cursor: 'pointer', color: '#dc3545' }}
            />
          </Button>
        </>
      ),
    };

    const cols2 = cols.some((col) => col.key === 'ID')
      ? [...cols, editDelColumns]
      : cols;
    setColumns(cols2);

    // Extract column names (keys) from the first item of data
    if (data.length > 0) {
      const cols = Object.keys(data[0]); // Get all columns from the first data object
      const cols2 = cols.some((col) => col === 'ID')
        ? [...cols, 'Action']
        : cols;
      setColumns2(cols2); // Set column names
      setSelectedColumns(cols2); // By default, all columns are selected
    }
  }, [data]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  var filteredData;
  try {
    filteredData = data.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(search.toLowerCase())
      )
    );
  } catch (error) {
    notification.error({ message: error.message });
  }

  const getBase64FromUrl = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const exportToPDF = async () => {
    // console.log('log response: ', response.data, 'daa:', printLogs)
    const doc = new jsPDF();
    const banner = `${API_URL}/${companyBanner}`;
    console.log('banner:', banner);
    // Convert image URL to Base64
    const imageBase64 = await getBase64FromUrl(banner);

    // Add the banner image
    const pageWidth = doc.internal.pageSize.getWidth();
    const imgHeight = 40; // Fixed height for the banner image
    const imgY = 10; // Start 10 units from the top

    doc.addImage(imageBase64, 'PNG', 0, imgY, pageWidth, imgHeight);

    // Add title below the banner image
    const titleY = imgY + imgHeight + 10;
    doc.setFontSize(16);
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    doc.text(title, titleX, titleY);

    // Add JSON key-value header data in a grid layout
    doc.setFontSize(12);
    let yOffset = titleY + 10; // Start position for the header
    if (reportHeader && reportHeader.length > 0) {
      const headerKeys = Object.entries(reportHeader[0]);

      for (let i = 0; i < headerKeys.length; i += 2) {
        const firstPair = headerKeys[i];
        const secondPair = headerKeys[i + 1];

        doc.text(`${firstPair[0]}: ${firstPair[1]}`, 14, yOffset);

        if (secondPair) {
          doc.text(`${secondPair[0]}: ${secondPair[1]}`, 110, yOffset);
        }

        yOffset += 7;
      }
    }

    // Compute unselected columns
    const unCheckedFields = columns2.filter(
      (col) => !selectedColumns.includes(col)
    );

    // Combine default fields with unchecked columns
    const combinedFieldsToRemove = [...fieldsToRemove, ...unCheckedFields];

    const printFilteredData = removeColumns(
      filteredData,
      combinedFieldsToRemove
    );

    const keys = Object.keys(printFilteredData[0]);

    const tableColumn = keys.map((col) => col);

    // console.log('Data: ', filteredData)
    const tableRows = filteredData.map((row) => {
      const record0 = columns.map((col) => row[col.key]);
      // const record = columns.map(col => escapeSingleQuotes(String(row[col.key])));

      //console.log('row:', row, 'record:', record0, 'record0:', record0); // Log the row to check if the data is correct
      return record0;
    });

    // Generate PDF with autoTable plugin
    doc.autoTable({
      startY: yOffset + 10, // Start table below the header

      head: [tableColumn],
      body: tableRows,
    });

    doc.save(title + '.pdf');

    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(printFilteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'pdf',
    };
    const response = await axios.post(insertUrl, printLogs, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  };

  const exportToExcel = async () => {
    // Compute unselected columns
    const unCheckedFields = columns2.filter(
      (col) => !selectedColumns.includes(col)
    );

    // Combine default fields with unchecked columns
    const combinedFieldsToRemove = [...fieldsToRemove, ...unCheckedFields];

    const printFilteredData = removeColumns(
      filteredData,
      combinedFieldsToRemove
    );

    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(printFilteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'excel',
    };
    const response = await axios.post(insertUrl, printLogs, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    const ws = XLSX.utils.json_to_sheet(printFilteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    XLSX.writeFile(wb, title + '.xlsx');
  };

  const exportToCsv = async (e) => {
    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(filteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'csv',
    };
    const response = await axios.post(insertUrl, printLogs, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  };

  const updateColumn = async (e, href) => {
    e.preventDefault();
    const updateUrl = `${API_URL}/${ENDPOINTS.SYS}/${href}`;
    try {
      const response = await axios.put(
        updateUrl,
        {},
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );

      //console.log(`response: `,response.data)
      notification.success({ message: response.data.message });
    } catch (error) {
      //console.log(`url: ${updateUrl}, error ${error.message}`)
      notification.error({ message: error.message });
    }
  };

  const undoDelUpdate = async (e, href) => {
    e.preventDefault();
    const updateUrl = `${API_URL}/${ENDPOINTS.SYS}/${href}`;
    try {
      const response = await axios.get(
        updateUrl,

        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );

      //console.log(`response: `,response.data)
      notification.success({ message: response.data.message });
    } catch (error) {
      //console.log(`url: ${updateUrl}, error ${error.message}`)
      notification.error({ message: error.message });
    }
  };

  const openInNewTab = async (e) => {
    e.preventDefault(); // Prevent default behavior of the Link

    // const noPrint = ['Action', 'Image', 'Print'];
    // const printFilteredData = removeFields(filteredData, noPrint)

    // Compute unselected columns
    const unCheckedFields = columns2.filter(
      (col) => !selectedColumns.includes(col)
    );

    // Combine default fields with unchecked columns
    const combinedFieldsToRemove = [...fieldsToRemove, ...unCheckedFields];

    const printFilteredData = removeColumns(
      filteredData,
      combinedFieldsToRemove
    );

    const jsonData = {
      title: title,
      logo: APP_LOGO,
      tableData: printFilteredData,
      reportHeader: reportHeader,
      reportFooter: reportFooter,
    };

    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(printFilteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'print',
    };
    const response = await axios.post(insertUrl, printLogs, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });

    localStorage.setItem('printData', JSON.stringify(jsonData)); // Store data in localStorage
    window.open('/print', '_blank'); // Open the link in a new tab
  };

  //console.log('columns:', columns);

  return (
    <div className="" style={{ padding: '20px' }}>
      <br />
      <div className="row">
        {/* {link?.reg_route && 
        <div className='col-6'>
            <button className="btn btn-primary" onClick={openModal}>
            {link?.reg_name}
          </button>
         
          <ModalForm userId={userId}  token={token} route={link?.reg_route} isOpen={isModalOpen} onRequestClose={closeModal} />
         
        </div>
         } */}
        <div className="col-3">
          <h2>{title}</h2>
        </div>
        {link?.reg_route && (
          <div className="col-6 ">
            <center>
              {link.reg_route.split(',').map((route, index) => (
                <>
                  <button
                    key={index}
                    className="btn btn-primary"
                    onClick={() => openModal2(route.trim())} // Pass the specific route to the modal
                  >
                    {link.reg_name.split(',')[index]}
                  </button>{' '}
                  &nbsp;
                </>
              ))}
            </center>
            {isModalOpen && (
              <ModalForm
                userId={userId}
                token={token}
                route={currentRoute} // Pass the dynamic route to the modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
              />
            )}
          </div>
        )}
      </div>

      {deleteId && (
        <DeleteModal
          userId={userId}
          token={token}
          table={link?.table_name}
          id={deleteId}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
        />
      )}
      {updateId && (
        <UpdateModal
          userId={userId}
          token={token}
          table={link?.table_name}
          update_link_id={link?.update_link_id}
          id={updateId}
          isOpen={isModalUpdateOpen}
          onRequestClose={closeUpdateModal}
        />
      )}
      {printedId && (
        <DetailData
          userId={userId}
          token={token}
          route="get-printed-data"
          title={title}
          id={printedId}
          isOpen={isModalPrintOpen}
          onRequestClose={closePrintModal}
        />
      )}

      {/* Flexbox container for the buttons and search */}

      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* Export Buttons - Left aligned */}
        {/* filteredData && filteredData.length > 0 && */}
        <div>
          <button onClick={exportToPDF} className="btn btn-primary mr-2">
            Export PDF
          </button>
          <a onClick={exportToCsv} className="" href="/">
            <CSVLink
              data={filteredData}
              filename={title + '.csv'}
              className="btn btn-success mr-2"
            >
              Export CSV
            </CSVLink>
          </a>
          <button onClick={exportToExcel} className="btn btn-warning mr-2">
            Export Excel
          </button>

          <Link
            to="/print"
            className="btn btn-info"
            onClick={openInNewTab} // Add the click handler
          >
            Print
          </Link>
        </div>
        {/* User Profile Dropdown */}
        <ul className="navbar-nav ms-auto">
          <li className="nav-item dropdown">
            <a
              className=" nav-link dropdown-toggle"
              href="/"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Show/Hide
            </a>
            <ul className="dropdown-menu " aria-labelledby="userDropdown">
              {columns2.map((column) => (
                <li key={column} lassName="dropdown-item">
                  &nbsp;
                  <label>
                    <input
                      type="checkbox"
                      checked={selectedColumns.includes(column)} // Check if this column is selected
                      onChange={() => handleCheckboxChange(column)} // Toggle checkbox
                    />
                    &nbsp;{column}
                  </label>
                </li>
              ))}
            </ul>
          </li>
        </ul>

        {/* Search Input - Right aligned */}
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={handleSearch}
          className="form-control mb-3"
          style={{ maxWidth: '300px' }} // Optional: Limit max width for better alignment
        />
      </div>
      <div className="container mt-4">
        {reportHeader && reportHeader.length > 0 && (
          <center>
            <h2>{title}</h2>
          </center>
        )}
        {reportHeader &&
          reportHeader.map((item, index) => (
            <div key={index} className="row mb-3">
              {Object.entries(item).map(([key, value], i) => (
                <div className="col-md-6 mb-2" key={i}>
                  <strong>{key}:</strong> {value}
                </div>
              ))}
            </div>
          ))}
      </div>
      {/* DataTable */}
      <DataTable
        //columns={columns}
        columns={columns.filter((col) => selectedColumns.includes(col.key))}
        dataSource={filteredData}
        rowKey="name"
        // scroll={{ x: 'max-content' }} // Adjusts table layout to prevent horizontal scrolling
        scroll={{ x: false }} // Disable horizontal scrolling
        locale={{
          emptyText:
            filteredData.length === 0
              ? 'No Data Available'
              : 'No matching data',
        }}
      />

      {executionTime !== null && (
        <p>
          Request executed in: {(executionTime / 100).toFixed(2)} sec - Total
          rows:{data.length} rows
        </p>
      )}
    </div>
  );
};

export default DTTable;
